import React from 'react';

interface StatsProps {
  text: string;
  value: number;
}

const Stats = ({ text, value }: StatsProps) => {
  return (
    <>
      <span className="mr-16 font-suisse-works text-[36px] font-bold text-primary-magenta sm:text-[80px]">
        {value}
      </span>
      <span className="font-suisse-screen text-caption-lg text-black sm:text-headline-md">
        {text}
      </span>
    </>
  );
};

export default Stats;
